module.exports = __webpack_public_path__ + "713b34b11f358febe035d194188866ab.pdf";